<template>
  <div class="activated-icon">
    <el-tooltip :content="tooltipText">
      <i :class="activatedIcon" />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ActivatedIcon',
  props: {
    isActivated: {
      type: Boolean,
      default: false
    },
    activatedText: {
      type: String
    },
    notActivatedText: {
      type: String
    }
  },
  computed: {
    tooltipText() {
      if (this.isActivated) {
        return this.activatedText ? this.activatedText : 'This account has been Activated'
      }
      return this.notActivatedText ? this.notActivatedText : 'This account is NOT Activated'
    },

    activatedIcon() {
      return this.isActivated ? 'el-icon-success' : 'el-icon-error'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~vars";

  .activated-icon {
    text-align: center;
    font-size: 24px;
  }

  .el-icon-success {
    color: $-color-success;
  }

  .el-icon-error {
    color: $-color-error;
  }
</style>
